export const tags = [
	{id: 1, name: 'android'},
	{id: 2, name: 'Bla'},
	{id: 3, name: 'Laaaaabel'},
];
